import { css } from "lit";
/**
 * see : https://github.com/shoelace-style/shoelace/blob/next/src/themes/light.styles.tshttps://github.com/shoelace-style/shoelace/blob/next/src/themes/light.styles.ts
 */
export default css `
a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
    display: block
}

body {
    line-height: 1;
    -webkit-text-size-adjust: 100%;
    -moz-text-size-adjust: 100%;
    text-size-adjust: 100%
}

ol,
ul {
    list-style: none
}

blockquote,
q {
    quotes: none
}

blockquote:after,
blockquote:before,
q:after,
q:before {
    content: '';
    content: none
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

*,
::after,
::before,
:after,
:before {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

button,
input,
select,
textarea {
    color: inherit;
    font-size: inherit;
    font-style: inherit;
    font-family: inherit;
    -webkit-border-radius: 0;
    border-radius: 0;
    -webkit-padding-start: 0;
    align-items: flex-start;
    border: none;
    outline: 0;
    background: 0 0;
    padding: 0;
    margin: 0;
    width: auto;
    height: auto;
    line-height: 1em
}

button,
input[type=color],
input[type=date],
input[type=datetime-local],
input[type=datetime],
input[type=email],
input[type=file],
input[type=month],
input[type=number],
input[type=password],
input[type=reset],
input[type=search],
input[type=submit],
input[type=tel],
input[type=text],
input[type=time],
input[type=url],
input[type=week],
select,
textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none
}

input[type=color] {
    width: 1em
}

input::-ms-clear {
    display: none
}

details,
summary {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none
}

mark {
    background: 0 0
}

hr {
    height: 1px;
    margin: 0;
    padding: 0
}

u {
    text-decoration: none
}

table th {
    text-align: left
}

a {
    color: inherit;
    outline: 0
}
`;
// All components import this file, so it's a good place to ensure utility styles are applied to the light DOM
const style = document.createElement("style");
document.head.append(style);
//# sourceMappingURL=reset.styles.js.map